
import { Layout } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppRoutes from "./jsx/layout/nav/AppRoutes";
import TopHeader from "./jsx/layout/TopHeader.js";
import { MenuList } from "./jsx/layout/nav/MenuList.js";
import FooterBar from "./jsx/layout/FooterBar.js";
import SubMenuBar from "./jsx/layout/SubMenuBar.js";
import { findMenuFromPath } from "./jsx/components/CustomView/menuUtils.js";
import { NotifyProvider, NotifyInitializer } from "./jsx/components/Customs/NotifyProvider.js";
import { setNavigator } from "./jsx/components/Customs/navigation.js";
import LoginPage from "./jsx/Page/LoginPage.js";

const { Content, Footer } = Layout;

function App() {
  const location = useLocation();
  const [activeParent, setActiveParent] = useState(null);

  const navigate = useNavigate();
  setNavigator(navigate);

  const ome_token = localStorage.getItem("user_key");
  const ome_user = localStorage.getItem("ome_user");

  useEffect(() => {
    const { parent } = findMenuFromPath(MenuList, location.pathname);
    setActiveParent(parent);
  }, [location.pathname]);

  if (!ome_token ) {
    return <LoginPage />;
  }

  return (
    <NotifyProvider>
      <Layout style={{ minHeight: "100vh" }}>
        <TopHeader
          activeParent={activeParent}
          setActiveParent={setActiveParent}
        />

        <SubMenuBar activeParent={activeParent} />

        <Content
          style={{
            margin: 10,
            paddingTop: 5,
            background: "#f7f9fc",
          }}
        >
          <AppRoutes />
        </Content>

        {/* <Footer style={{ textAlign: "center" }}> */}
          <FooterBar />
        {/* </Footer> */}
      </Layout>
      <NotifyInitializer />
    </NotifyProvider>
  );
}

export default App;
